import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serverChanner, gmToolNewPage } from "@/mixins/index";
import addbeforeLogin from "./components/addbeforeLogin";
import { loginBeforeAnnounceData, loginBeforeAnnounceDel, gameByPkg } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "beforeLogin",
  mixins: [loadMoreList, serverChanner, gmToolNewPage],
  components: {
    addbeforeLogin: addbeforeLogin
  },
  data: function data() {
    return {
      pagingReqFn: loginBeforeAnnounceData,
      pagingReqValue: "data",
      paramsData: {
        id: '',
        content: '',
        author: '',
        top: '',
        state: '0',
        pkgs: []
      },
      drawer: false,
      content: '',
      delIds: [],
      date: [],
      state: [{
        label: this.$t('all'),
        value: '0'
      }, {
        label: this.$t('enabled'),
        value: 1
      }, {
        label: this.$t('disabled'),
        value: 2
      }]
    };
  },
  activated: function activated() {
    this.getPkgList();
    this.getList();
  },
  methods: {
    getPkgList: function getPkgList() {
      var _this = this;

      gameByPkg({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this.pkgList = res.data;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    datechange: function datechange(e) {},
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: loginBeforeAnnounceDel,
        data: {
          id: ids.toString(),
          env_id: this.paramsData.env_id
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};